"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = _interopRequireDefault(require("../../../../../Framework/ComponentContainer"));
var _configuration = require("../../../../configuration");
var _ServiceLocator = require("../../../../ServiceLocator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps() {
  return {
    availableTools: (0, _configuration.getConf)('availableTools')
  };
};
var mapDispatchToProps = function mapDispatchToProps() {
  return {
    onFastConfiguration: function onFastConfiguration() {
      return _ServiceLocator.Services.ui.show('fastConfiguration');
    },
    onSave: function onSave() {
      return _ServiceLocator.Services.interaction.saveConfiguration();
    },
    onShare: function onShare() {
      return _ServiceLocator.Services.interaction.shareConfiguration();
    },
    onPrint: function onPrint() {
      return _ServiceLocator.Services.interaction.printConfiguration();
    },
    onLoad: function onLoad() {
      return _ServiceLocator.Services.interaction.loadConfiguration();
    }
  };
};
var _default = exports["default"] = (0, _ComponentContainer["default"])(mapStateToProps, mapDispatchToProps);